enum QuestionType {
	Undefined       = 0,
	YesNo           = 1,
	Legal           = 2,
	Integer         = 3,
	Decimal         = 4,
	Date            = 5,
	Text            = 6,
	TextArea        = 7,
	Currency        = 8,
	MultipleChoice  = 9,
	DropDown        = 10,
	FileUpload      = 11,
}

export default QuestionType;
